<template>
  <el-container class="entertainmentPlaceJB">
    <el-card class="tree-card" :body-style="treeCard">
      <div class="tree-box">
        <el-card
          :class="{ hoverCard: ListIndex === index }"
          style="cursor: pointer"
          v-for="(item, index) in list"
          :key="index"
          shadow="always"
          @click="ListClick(item, index)"
        >
          <div class="mycard">
            <span>{{ item.value }}</span>
          </div>
        </el-card>
      </div>
    </el-card>
    <el-card class="tabs-card">
      <div class="tableForm">
        <el-form :inline="true" :model="tableParams" class="demo-form-inline">
          <template v-for="item in formList" :key="item.id">
            <el-form-item :label="item.name" class="tableFormItem">
              <el-select
                v-model="item.operatorText"
                placeholder="请选择"
                @change="
                  () => {
                    tableParams[item.fields] = '';
                  }
                "
              >
                <!-- operatorsList -->
                <el-option
                  v-for="it in operatorsCom(item.operators)"
                  :key="it.id"
                  :label="it.value"
                  :value="it.code"
                >
                </el-option>
              </el-select>
              <!-- 输入 -->
              <template v-if="item.defaultConfiguration === '1'">
                <el-input
                  placeholder="请输入"
                  clearable
                  v-model="tableParams[item.fields]"
                ></el-input>
              </template>
              <!-- 时间 -->
              <template v-if="item.defaultConfiguration === '2'">
                <el-date-picker
                  v-if="item.operatorText != '13'"
                  v-model="tableParams[item.fields]"
                  type="datetime"
                  placeholder="请选择时间"
                />
                <el-date-picker
                  v-else
                  v-model="tableParams[item.fields]"
                  type="datetimerange"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                />
              </template>
              <!-- 下拉 -->
              <template v-if="item.defaultConfiguration === '3'">
                <h-selectcode
                  :type="item.dictConversion"
                  v-model="tableParams[item.fields]"
                  placeholder=" "
                ></h-selectcode>
              </template>
            </el-form-item>
          </template>
          <el-form-item>
            <el-button type="primary" @click="refreshTable('form')"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="setUpFormClick">配置</el-button>
      </div>
      <div class="table-box">
        <h-table
          ref="tableRef"
          v-model:data="tableData"
          v-model:columns="columns"
          :method="tablelist"
          :params="tableParams"
          :showSort="true"
          :autoload="false"
          @select="hzTableSelect"
          @tableInfo="tableInfo"
          @sort="tableSort"
        >
          <template #unitName="{ row }">
            <div class="table-role" @click="clickTable(row)">
              <span>{{ row.unitName }}</span>
            </div>
          </template>
        </h-table>
      </div>
    </el-card>
    <setUpForm
      v-if="setUpVisible"
      v-model:visible="setUpVisible"
      :lableData="columns"
      :tableInfo="tableParams.tableName"
      @refreshDict="getFormList"
    ></setUpForm>
  </el-container>
</template>
<script>
import { defineComponent, computed, reactive, toRefs, ref } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { tablelist, configureList } from "@/api/threeSolid/dataQueryApi.js";
import { getMenutree } from "@/api/system/region.js";
import { getDict } from "@/api/constant.js";
import setUpForm from "./components/setUpForm.vue";

import _ from "lodash";
import moment from "moment";
export default defineComponent({
  name: "entertainmentPlaceJB",
  components: { setUpForm },
  props: {},
  setup(props) {
    const state = reactive({
      ListIndex: 0,
      list: [],
      imgMoren: require("@/assets/images/moren.png"),
      tableSelection: [],
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      userFormData: {},
      tableParams: {
        tableName: "",
        operators: [],
        orderFields: [],
      },
      tableData: [],
      formStatus: 1, // 1 添加  2 编辑
      formVisible: false,
      setUpVisible: false,
      columns: [],
      formList: [],
      operatorsList: [],
    });
    const refData = toRefs(state);
    // const treeRef = ref(null);
    const tableRef = ref(null);
    const formRef = ref(null);

    // 点击查询按钮
    const refreshTable = (val) => {
      if (val === "form") state.tableParams.orderFields = [];
      state.tableParams.operators = [];
      let dateType;
      state.formList.forEach((item) => {
        for (let key in state.tableParams) {
          if (state.tableParams[key] && item.fields == key) {
            //输入框是时间时分单个和数组这里统一转数组
            if (item.defaultConfiguration === "2") {
              console.log(state.tableParams[key].length);
              if (state.tableParams[key].length == 2) {
                dateType = _.cloneDeep(state.tableParams[key]);
              } else {
                dateType = _.cloneDeep([state.tableParams[key], null]);
              }
            }
            let obj = {
              columnName:
                item.defaultConfiguration === "2"
                  ? `UNIX_TIMESTAMP(${key})`
                  : key,
              operator: item.operatorText,
              value:
                item.defaultConfiguration === "2"
                  ? new Date(dateType[0]).getTime() / 1000
                  : state.tableParams[key],
              value2:
                item.defaultConfiguration === "2" && dateType[1]
                  ? new Date(dateType[1]).getTime() / 1000
                  : "",
            };
            state.tableParams.operators.push(obj);
          }
        }
      });
      tableRef.value && tableRef.value.refresh();
    };
    // 重置表单
    const resetForm = (formEl) => {
      if (!formEl) return;
      formEl.resetFields();
    };
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    const hzTableSelect = (selection) => {
      state.tableSelection = selection;
    };
    const clickTable = async (item) => {
      state.userFormData = _.cloneDeep(item);
      state.formStatus = 3;
      state.formVisible = true;
    };
    const ListClick = (item, index) => {
      state.ListIndex = index;
      state.tableParams.tableName = item.remark;
      const arr = ["tableName", "operators", "orderFields"];
      for (let key in state.tableParams) {
        if (!arr.includes(key)) {
          Reflect.deleteProperty(state.tableParams, key);
        }
      }
      state.tableParams.orderFields = [];
      state.formList = [];
      getFormList();
      refreshTable();
    };
    const tableInfo = (val) => {
      state.columns = val
        .filter((item) => item.columnComment)
        .map((itme) => {
          return {
            label: itme.columnComment,
            prop: itme.columnName,
            dataType: itme.dataType,
          };
        });
      tableRef.value.initColumnList();
    };
    const getDictAxios = async () => {
      const res = await getDict("data_select");
      const resOperator = await getDict("operator_fileld");
      state.list = res.dict;
      state.operatorsList = resOperator.dict;
      ListClick(res.dict[0], 0);
    };
    getDictAxios();
    const setUpFormClick = () => {
      state.setUpVisible = true;
    };
    //获取form表单数据
    const getFormList = async () => {
      let params = {
        tableInfo: state.tableParams.tableName,
        isPage: false,
      };
      const res = await configureList(params);
      if (res.code == 0 && res.page.list.length > 0) {
        state.formList = res.page.list.map((item) => {
          const initText = item.operators.split(",")[0];
          item.operatorText = initText;
          return item;
        });
      }
    };
    //根据表单渲染输入框前面的下拉框
    const operatorsCom = (list) => {
      return state.operatorsList.filter((item) => {
        if (list.split(",").includes(item.code)) {
          return item;
        }
      });
    };
    //表格排序
    const tableSort = (columns, a, b) => {
      console.log(columns, a, b);
      if (!columns.prop) return;
      let obj = {
        fieldName: columns.column.property,
        orderType: columns.order === "descending" ? "1" : "2",
      };
      if (state.tableParams.orderFields.length == 0) {
        state.tableParams.orderFields.push(obj);
      } else {
        state.tableParams.orderFields = state.tableParams.orderFields.filter(
          (item) => {
            if (obj.fieldName !== item.fieldName) {
              return item;
            }
          }
        );
        console.log(state.tableParams.orderFields);
        state.tableParams.orderFields.push(obj);
      }
      refreshTable();
    };
    return {
      ...refData,
      tableInfo,
      ListClick,
      clickTable,
      refreshTable,
      resetForm,
      hzTableSelect,
      tablelist,
      formRef,
      tableRef,
      setUpFormClick,
      getFormList,
      operatorsCom,
      tableSort,
    };
  },
});
</script>
<style lang="scss" scoped>
.entertainmentPlaceJB {
  .tree-card {
    height: 100%;
    width: 300px;

    .tree-box {
      flex: 1;
      overflow: auto;
      position: relative;
      .el-card {
        margin-bottom: 10px;
      }
      .hoverCard {
        // background: red;
        border: 1px solid #3a74fb;
        border-left: 5px solid #3a74fb;
        color: #3a74fb;
      }
      .tree-header {
        position: sticky;
        top: 0;
        z-index: 2;
        padding: 10px 0;
        background-color: var(--el-color-white);
        color: var(--el-text-color-regular);
        @include flex-row-sb-c;
        .tree-name {
          flex: 1;
          margin-right: 10px;
          padding-left: 48px;
        }
        .tree-status {
          width: 50px;
        }
      }
    }
  }
  .tabs-card {
    flex: 1;
    margin-left: 10px;
    .tableForm {
      display: flex;
      justify-content: space-between;
      :deep(.el-form-item__content) {
        flex-wrap: nowrap;
        :deep(.el-input__inner) {
          border-radius: 0;
        }
      }
      :deep(.el-select .el-input) {
        width: 110px;
      }
      .el-form {
        max-height: 100px;
        overflow: auto;
      }
    }
    .tabs-tabel-box {
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    .table-box {
      flex: 1;
      overflow: hidden;
      img {
        width: 42%;
        height: 90px;
      }
      .table-role {
        color: #294a7c;
        cursor: pointer;
        span {
          border-bottom: 1px solid;
        }
      }
    }
  }
}
</style>
